import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=24ab7bde&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ab7bde')) {
      api.createRecord('24ab7bde', component.options)
    } else {
      api.reload('24ab7bde', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=24ab7bde&", function () {
      api.rerender('24ab7bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20C1P7QHSytDB/JS/imageCarousel.vue"
export default component.exports